// PREFETCH NAVIGATOR
// Strategy: hover-intent only, fires ONLY after window load event
// so it NEVER competes with the page's own resources.
// Hard cap: 5 prefetches max. No click interception. No View Transitions.
// Passive <link rel="prefetch"> only — browser discards if caching is blocked.

(function() {
  'use strict';

  var prefetched = new Set();
  var MAX_PREFETCH = 5;
  var HOVER_DELAY_MS = 100;
  var pageLoaded = false;
  var hoverTimers = {};

  function isProductOrCollectionLink(url) {
    try {
      var u = new URL(url, window.location.origin);
      if (u.origin !== window.location.origin) return false;
      return /^\/(products|collections)\//.test(u.pathname);
    } catch (e) { return false; }
  }

  function prefetchUrl(url) {
    if (!pageLoaded) return;           // never before load event
    if (prefetched.size >= MAX_PREFETCH) return;
    if (prefetched.has(url)) return;
    if (!isProductOrCollectionLink(url)) return;

    prefetched.add(url);
    var link = document.createElement('link');
    link.rel = 'prefetch';
    link.as = 'document';
    link.href = url;
    document.head.appendChild(link);
  }

  function onLinkMouseEnter(e) {
    var a = e.currentTarget;
    var url = a.href;
    if (!url || prefetched.has(url)) return;
    hoverTimers[url] = setTimeout(function() {
      prefetchUrl(url);
    }, HOVER_DELAY_MS);
  }

  function onLinkMouseLeave(e) {
    var url = e.currentTarget.href;
    if (hoverTimers[url]) {
      clearTimeout(hoverTimers[url]);
      delete hoverTimers[url];
    }
  }

  function attachHoverListeners() {
    document.querySelectorAll('a[href]').forEach(function(a) {
      if (isProductOrCollectionLink(a.href)) {
        a.addEventListener('mouseenter', onLinkMouseEnter, { passive: true });
        a.addEventListener('mouseleave', onLinkMouseLeave, { passive: true });
        // Mobile: touchstart fires before navigation, gives ~50ms head start
        a.addEventListener('touchstart', function() {
          prefetchUrl(a.href);
        }, { passive: true });
      }
    });
  }

  // Public stats for debugging
  window._nbPrefetch = {
    stats: function() {
      return {
        prefetchedCount: prefetched.size,
        prefetchedUrls: Array.from(prefetched),
        pageLoaded: pageLoaded
      };
    }
  };

  // CRITICAL: Only activate AFTER the load event — never during page load
  window.addEventListener('load', function() {
    pageLoaded = true;
    // Small additional delay to let 3rd party scripts finish their initial work
    setTimeout(attachHoverListeners, 500);
  });

})();
